/**
 * [创建小运力公司弹窗组件]
 * @author: Fu Xiaochun
 * @date: 2022-05-26 
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Modal, Select, message, } from 'antd';
import moment from 'moment';
import BaseInfo from './BaseInfo';
import IdInfo from './IdInfo';
import BusinessLicense from './BusinessLicense';
import Agreements from './Agreements';
import BankInfo from './BankInfo';
import SettleModel from './SettleModel';
import * as apis from '@/apis/operation/transportCompany';

const { Option } = Select;

function CreateTransportCompany(props) {

    const $baseInfo = useRef();
    const $idInfo = useRef();
    const $businessLicense = useRef();
    const $agreements = useRef();
    const $bankInfo = useRef();
    const $settleModel = useRef();

    const [bankAccountName, setBankAccountName] = useState('');

    const [detail, setDetail] = useState({});


    useEffect(() => {
        if (props.editId) {
            getDetail();
        }
    }, []);

    const getDetail = () => {
        apis.getSmallTransportDetail({ id: props.editId }).then(res => {
            setDetail(res.result);
        }).catch(err => {
            message.error(err.message);
        });
    };

    // 对账日
    // const [billsCheckDate, setBillsCheckDate] = useState();  // 对账日
    const days = Array(28).fill().map((v, k) => k + 1);

    const onClose = () => {
        props.onClose && props.onClose();
    };

    const collectData = () => {
        let baseInfoData = $baseInfo.current.getState();
        let idInfoData = $idInfo.current.getState();
        let businessLicenseData = $businessLicense.current.getState();
        let agreementsData = $agreements.current.getState();
        let bankInfoData = $bankInfo.current.getState();
        let settleModelData = $settleModel.current.getState();


        // let formData = {...baseInfoData, ...businessLicenseData, ...agreementsData, ...bankInfoData, ...settleModelData, billsCheckDate};
        let formData = { ...baseInfoData, identityInfo: { ...idInfoData }, ...businessLicenseData, ...agreementsData, ...bankInfoData, ...settleModelData };

        return formData;
    };

    const validate = (data) => {
        if (!data.companyLogo) {
            message.error('请上站点logo！');
            return false;
        }
        if (!data.companyName) {
            message.error('请输入站点名称！');
            return false;
        }
        if (!data.contactName) {
            message.error('请输入联系人姓名！');
            return false;
        }
        if (!data.contactTel) {
            message.error('请输入联系人手机！');
            return false;
        }
        if (!data.provinceId || !data.cityId || !data.areaId) {
            message.error('请选择所在区域！');
            return false;
        }
        if (!data.opId) {
            message.error('请选择运营中心！');
            return false;
        }
        if (!data.address) {
            message.error('请输入详细地址！');
            return false;
        }

        // 校验身份证信息
        let idStatus = true;
        for (let k in data.identityInfo) {
            if (k == 'sex') {
                continue;
            }
            if (!data.identityInfo[k]) {
                idStatus = false;
                break;
            }
        }
        if (!idStatus) {
            message.error('请完善身份证信息');
            return false;
        }

        if (!data.agreementsFile) {
            message.error('请上传合作协议！');
            return false;
        }
        if (!data.agreementsTime) {
            message.error('请输入协议有效期！');
            return false;
        }

        if (!data.bankAccountName) {
            message.error('请输入银行账户名称！');
            return false;
        }
        if (!data.bankAccountId) {
            message.error('请输入银行卡号！');
            return false;
        }
        if (!/^\d{16,}$/.test(data.bankAccountId)) {
            message.error('请输入正确的银行卡号！');
            return false;
        }
        if (!data.bankCode) {
            message.error('请选择开户银行！');
            return false;
        }
        if (!data.subBankCode) {
            message.error('请选择开户行支行！');
            return false;
        }
        if (!/^1[3-9]\d{9}$/.test(data.bankTel)) {
            message.error('请输入银行预留手机号！');
            return false;
        }

        if (!data.settleModel) {
            message.error('请选择结算模式！');
            return false;
        }

        // if (!data.platRatio && data.platRatio !== 0) {
        //     message.error('请输入平台服务费比例！');
        //     return false;
        // }
        // if (!data.operationCenterRatio && data.operationCenterRatio !== 0) {
        //     message.error('请输入市级运营中心服务费比例！');
        //     return false;
        // }
        if (data.settleModel == 'FULL' && !data.areaCompanyRatio && data.areaCompanyRatio !== 0) {
            message.error('请输入运营公司分润比例！');
            return false;
        }
        if (!data.riderRatio && data.riderRatio !== 0) {
            message.error('请输入骑手配送费比例！');
            return false;
        }
        if (data.settleModel == 'REVENUE_ONLY' && !data.companyRatio && data.companyRatio !== 0) {
            message.error('请输入站点分润比例！');
            return false;
        }

        if (data.settleModel == 'REVENUE_ONLY') {
            if (data.operationCenterRatio + data.areaCompanyRatio + data.companyRatio > 100) {
                message.error('运营中心和站点结算比例之和不能超过100%!');
                return false;
            }
        } else {
            if (data.operationCenterRatio + data.areaCompanyRatio > 100) {
                message.error('运营中心结算比例之和不能超过100%!');
                return false;
            }
        }


        // if(!data.billsCheckDate){
        //     message.error('请选择对账日！');
        //     return false;
        // }

        return true;
    };

    const onSubmit = () => {
        let data = collectData();

        if (!validate(data)) {
            return false;
        }

        let authCache = localStorage.getItem('auth') || '{}';
        let auth = JSON.parse(authCache);

        let formData = {
            id: props.editId ? props.editId : undefined,
            transportLogo: data.companyLogo,
            transportName: data.companyName,
            contactName: data.contactName,
            tel: data.contactTel,
            provinceId: data.provinceId,
            cityId: data.cityId,
            areaId: data.areaId,
            opId: data.opId,
            address: data.address,

            identityInfo: { ...data.identityInfo },

            businessLicenseUrl: data.licenseImg,
            businessLicenseNo: data.businessLicenseId,
            enterpriseName: data.businessLicenseName,
            expireTime: data.expirationTime ? data.expirationTime : undefined,
            expireType: data.permanent ? 2 : data.expirationTime ? 1 : undefined,

            agrtFileUrl: data.agreementsFile,
            agrtEndTime: data.agreementsTime,

            bankType: data.bankAccountType,
            bankAccountName: data.bankAccountName,
            bankAccount: data.bankAccountId,
            bankTel: data.bankTel,         // 银行预留电话
            openBank: data.bankName,       // 开户行名称
            openBankCode: data.bankCode,       // 开户行CODE
            bankName: data.subBankName,    // 开户行支行
            branchCode: data.subBankCode,  // 开户行支行code

            settleType: data.settleModel,
            // opRatio: data.platRatio,
            // operationCenterRatio: data.operationCenterRatio,
            areaCompanyRatio: data.areaCompanyRatio,
            riderRatio: data.riderRatio,
            smallTransportRatio: data.companyRatio,

            adminEmplLoginName: auth.userInfo.emplName,


            // reconciliationDay: data.billsCheckDate
        };

        apis.editSmallTransport(formData).then(res => {
            message.success('创建成功！');
            props.onOk();
        }).catch(err => {
            message.error(err.message);
        });
    };

    return (
        <Modal open={true} title={props.editId ? '修改站点' : '创建站点'} onOk={onSubmit} onCancel={onClose} centered={true} okText="提交审核" width="860px" bodyStyle={{ padding: '10px 30px 30px 30px', height: '600px', overflow: 'auto' }} destroyOnClose={true} >
            <div className={styles.container}>

                <div className={styles.sectionTitle}><span>*</span><strong>基本信息</strong></div>
                <BaseInfo ref={$baseInfo} detail={detail} />

                <div className={styles.sectionTitle}><span>*</span><strong>身份信息</strong></div>
                <IdInfo ref={$idInfo} setBankAccountName={setBankAccountName} detail={detail} />

                <div className={styles.sectionTitle}><strong>营业执照</strong></div>
                <BusinessLicense ref={$businessLicense} detail={detail} />

                <div className={styles.sectionTitle}><span>*</span><strong>合作协议</strong></div>
                <Agreements ref={$agreements} detail={detail} />

                <div className={styles.sectionTitle}><span>*</span><strong>银行账户信息</strong></div>
                <BankInfo ref={$bankInfo} bankAccountName={bankAccountName} detail={detail} />

                <div className={styles.sectionTitle}><span>*</span><strong>结算模式</strong></div>
                <SettleModel ref={$settleModel} detail={detail} />

                {/* <div className={styles.sectionTitle}><span>*</span><strong>对账日</strong></div>
                <div className={styles.billsCheckDate}>
                    <div className={styles.item}>
                        <div className={styles.label}>对账日：</div>
                        <div className={styles.val}>
                            每月
                            <Select placeholder='请选择' className={styles.txt} onChange={setBillsCheckDate} value={billsCheckDate}>
                                {days.map(item => <Option key={item} value={item} >{item}</Option>)}
                            </Select>
                            日
                        </div>
                    </div>
                </div> */}

            </div>
        </Modal>
    );
}

CreateTransportCompany.propTypes = {
    onOk: PropTypes.func,
    onClose: PropTypes.func,
    editId: PropTypes.number
};

export default CreateTransportCompany;